import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BenchmarkPage = lazy(() => import('./BenchmarkPage'));

const path = 'reports/benchmark';
const BenchmarkRoute: FuseRouteItemType = {
	path: path,
	element: <BenchmarkPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Benchmark',
					showCrumbs: false,
					helpName: 'Benchmark'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default BenchmarkRoute;
